var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEcaSummary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.16967 2H3.99992C3.63173 2 3.33325 2.29848 3.33325 2.66667V10.6667H1.33325V12.6667C1.33325 13.7733 2.22659 14.6667 3.33325 14.6667H11.3333C12.4399 14.6667 13.3333 13.7733 13.3333 12.6667V10.279C12.9128 10.4492 12.4657 10.5673 11.9999 10.6254V12.6667C11.9999 13.0333 11.6999 13.3333 11.3333 13.3333C10.9666 13.3333 10.6666 13.0333 10.6666 12.6667V10.6667H4.66659V3.33333H6.3876C6.58342 2.84956 6.84817 2.40105 7.16967 2ZM2.66659 12.6667C2.66659 13.0333 2.96659 13.3333 3.33325 13.3333H9.33325V12H2.66659V12.6667Z",
    fill: "#6A7F9F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02575 5.31321C9.35459 5.91422 10.419 6.97866 11.02 8.3075L11.3333 9L11.6465 8.3075C12.2475 6.97866 13.3119 5.91422 14.6407 5.31321L15.3333 5L14.6407 4.68679C13.3119 4.08578 12.2475 3.02134 11.6465 1.6925L11.3333 1L11.02 1.6925C10.419 3.02134 9.35459 4.08578 8.02575 4.68679L7.33325 5L8.02575 5.31321Z",
    fill: "#4555D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcaSummary);
export default __webpack_public_path__ + "static/media/eca-summary.3ce30b959f91f316508dbebc326b2958.svg";
export { ForwardRef as ReactComponent };